/** Lightweight SVG sparkline (no recharts) for KPI cells and list rows. Solid alpha fill, no gradients. */
export const Sparkline = ({ values = [], width = 96, height = 28, color = "hsl(var(--primary))", fill = true, strokeWidth = 1.5, className }) => {
  const pts = values.filter((v) => typeof v === "number" && !Number.isNaN(v));
  if (pts.length < 2) return null;
  const lo = Math.min(...pts);
  const hi = Math.max(...pts);
  const padV = (hi - lo || Math.abs(hi) || 1) * 0.15;
  const min = lo - padV;
  const max = hi + padV;
  const span = max - min || 1;
  const stepX = width / (pts.length - 1);
  const pad = 2;
  const coords = pts.map((v, i) => [i * stepX, pad + (height - pad * 2) * (1 - (v - min) / span)]);
  const d = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const area = `${d} L${width},${height} L0,${height} Z`;
  const [lx, ly] = coords[coords.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={className} aria-hidden="true">
      {fill ? <path d={area} fill={color} fillOpacity="0.08" /> : null}
      <path d={d} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lx} cy={ly} r="2" fill={color} />
    </svg>
  );
};
